export default __webpack_public_path__ + "static/media/975ccca4-76d8-40fc-a2a8-58e89d4554dc.755e4fcc.jpeg";